import { Location } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentData, FileWithContentUpload, OrganizationDocumentsUpdateItem } from 'src/app/models/dataModels';
import { APIService } from 'src/app/services/APIService';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { ConstantsModule } from 'src/app/services/constants.module';
import { LocalUtilService } from 'src/app/services/local-util.service';
import { MessagesService } from 'src/app/services/messages.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { PopupComponent } from '../popup/popup.component';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-upload-visura',
    templateUrl: './upload-visura.component.html',
    styleUrls: ['./upload-visura.component.css'],
    standalone: false
})
export class UploadVisuraComponent extends APIService implements OnInit, OnDestroy {

  constructor(public localService: LocalUtilService,
    public authService: AuthService,
    public organizationService: OrganizationService,
    private modalService: NgbModal,
    private messageService: MessagesService,
    location: Location, 
    router: Router,
    public route: ActivatedRoute,
    public commonService: CommonService,
    translateService: TranslateService) {
    super(localService, location, router, translateService);
    console.log('UploadVisuraComponent()');
  }

  visuraCamerale: FileWithContentUpload;
  vatnumber: string;
  existsDocument: DocumentData;
  private subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.checkVisuraDoc();
    let vatnumber = this.route.snapshot.paramMap.get('vatnumber');
    if (vatnumber != undefined) {
      this.vatnumber = vatnumber;
      console.log('UploadVisuraComponent() set vatnumber to ' + this.vatnumber);
    } else {
      if (this.isUser() && vatnumber == undefined) {
        this.vatnumber = this.localUtil.authParams.organization_detail.orgname;
      } 
    }
  }

  back() {
    this.location.back();
  }

  getVisuraCameraleFile(file) {
    if (file != undefined) {
      console.log('getVisuraCameraleFile() loaded file: ' + file.name);
    }else {
      console.log('getVisuraCameraleFile() unloaded file!');
    }
    this.visuraCamerale = new FileWithContentUpload();
    this.visuraCamerale.file = file;
  }

  documentUpload() {
    this.back();
  }

  uploadVisura() {
    if (this.visuraCamerale != undefined && this.visuraCamerale.file != undefined) {
      this.visuraCamerale.contentType = 'ORG';
      this.visuraCamerale.vatnumber = this.vatnumber;
      
      const service = this.commonService.documentUpload(this.visuraCamerale).subscribe(
        data => {
          data = JSON.parse(data);
          console.log('visuraCamerale uploaded! file_uuid: ' + data.file_uuid);
          console.log(data);
          this.updateVisura(this.visuraCamerale.vatnumber, data.file_uuid);
        }, this.handleError(true));
      this.subscriptions.push(service);
    } else {
      this.localUtil.showMessage("", ConstantsModule.INFO_TITLE, this.messageService.getLabelFromCode("UPLOAD_FORM_FILE_NOT_LOADED"), true);
    }
  }

  updateVisura(vatnumber: string, uuid: string) {
    
        let updateBean:OrganizationDocumentsUpdateItem = new OrganizationDocumentsUpdateItem();
        updateBean.visuraCameraleUuid = uuid;

        const service = this.organizationService.updateOrganizationDocuments(vatnumber, updateBean).subscribe(
          (data:any) => {
            
            if (this.isUser()) {
              let authParam = this.localUtil.authParams;
              authParam.organization_detail.visuraCamerale = data.detail.visuraCamerale;
              authParam.organization_detail.visuraCameraleValidated = "";
              this.localUtil.setAuthParams(authParam);
            }

            const modalRef = this.modalService.open(PopupComponent);
            modalRef.componentInstance.titolo = this.messageService.getLabelFromCode("INFO_TITLE");
            modalRef.componentInstance.messaggio = this.messageService.getLabelFromCode("GENERIC_SUCCESS_MESSAGE_SAVE");
            modalRef.componentInstance.tipo = 'message';
            const service = modalRef.componentInstance.passEntry.subscribe((receivedEntry:any) => {
              this.back();
            });
            this.subscriptions.push(service);

      },
      this.handleError(true));
      this.subscriptions.push(service);

  }

  checkVisuraDoc() {
    console.log('checkVisuraDoc()');
    let organization_detail = this.localUtil.getSessionOrganization();
    if (organization_detail != '' && organization_detail != undefined) {
      if (organization_detail.visuraCamerale != '' &&
          organization_detail.visuraCameraleValidated == '') {
            //EXISTS AND NOT YET VALIDATED
            console.log('visura camerale EXISTS AND NOT YET VALIDATED');            
            this.existsDocument = new DocumentData();
            this.existsDocument.uuid = organization_detail.visuraCamerale;
            this.existsDocument.status = '';
      } else if (organization_detail.visuraCamerale != '' &&
                 organization_detail.visuraCameraleValidated == 'Y') {
            //EXISTS AND VALIDATED
            console.log('visura camerale EXISTS AND VALIDATED');
            this.existsDocument = new DocumentData();
            this.existsDocument.uuid = organization_detail.visuraCamerale;
            this.existsDocument.status = 'Y';
      } else if (organization_detail.visuraCamerale != '' &&
                 organization_detail.visuraCameraleValidated == 'N') {
            //EXISTS AND NOT VALIDATED
            this.existsDocument = new DocumentData();
            console.log('visura camerale EXISTS AND NOT VALIDATED');
            this.existsDocument.uuid = organization_detail.visuraCamerale;
            this.existsDocument.status = 'N';
      } else {
            //UNKNOWN STATUS
            console.log('visura camerale UNKNOWN STATUS');
            this.existsDocument = new DocumentData();
            this.existsDocument.uuid = '';
            this.existsDocument.status = '';
      }  
    }
  }

  ngOnDestroy() {
    try {
      this.subscriptions.forEach(sub => {
                
        sub.unsubscribe()
      });
    } catch (err) {
      //
    }
  }

}